/**
 * Seasonly — Halloween & Thanksgiving sub-seasons.
 * Runs after seasonly.js. Keeps the Fall tab highlighted for both holidays and
 * swaps the banner particles for bats/ghosts/pumpkins (Halloween) or
 * turkeys/pumpkins/leaves/acorns (Thanksgiving).
 */
(function () {
  var root = document.documentElement;
  var PARENT = { halloween: 'fall', thanksgiving: 'fall' };
  var SHAPES = {
    halloween: [
      '<svg viewBox="0 0 48 24"><path d="M24 4c-2 3-4 4-7 4-3 0-5-2-7-5-1 4 0 7 2 9-4 0-8 2-12 6 5-1 9 0 12 3 2-3 4-4 6-4 1 2 3 4 6 5 3-1 5-3 6-5 2 0 4 1 6 4 3-3 7-4 12-3-4-4-8-6-12-6 2-2 3-5 2-9-2 3-4 5-7 5-3 0-5-1-7-4z" fill="#1a1124" opacity="0.85"/></svg>',
      '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="14" rx="9" ry="8" fill="#f28a2a"/><path d="M12 6c1-3 2-4 3-4-1 1-1 3-1 4z" fill="#3d7a2a"/><path d="M8 12l2 2-2 1zM16 12l-2 2 2 1zM8 17c2 2 6 2 8 0" fill="#1a1124" stroke="#1a1124" stroke-width="1"/></svg>',
      '<svg viewBox="0 0 24 24"><path d="M12 2c5 0 8 4 8 9v11l-2.5-2-2.5 2-3-2-3 2-2.5-2L4 22V11c0-5 3-9 8-9z" fill="#ffffff" opacity="0.9"/><circle cx="9.5" cy="10" r="1.3" fill="#1a1124"/><circle cx="14.5" cy="10" r="1.3" fill="#1a1124"/></svg>'
    ],
    thanksgiving: [
      '<svg viewBox="0 0 32 32"><path d="M16 6l3-5 1 5 4-4-1 5 5-2-3 4 5 0-4 3 5 2-5 1 3 4-5-2 1 5-4-4-1 5-3-5-3 5-1-5-4 4 1-5-5 2 3-4-5-1 5-2-4-3 5 0-3-4 5 2-1-5 4 4 1-5z" fill="#b5451b"/><ellipse cx="16" cy="20" rx="7" ry="6" fill="#6b3a1f"/><circle cx="16" cy="14" r="3.2" fill="#8b5a2b"/><path d="M16 14l2 1-2 1z" fill="#e0a030"/><path d="M15 15.5c0 1.5 0 2.5 1 3" stroke="#c8301c" stroke-width="1.2" fill="none"/></svg>',
      '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="14" rx="9" ry="8" fill="#e8731a"/><path d="M8 6c0 4 0 12 0 16M16 6c0 4 0 12 0 16" stroke="rgba(0,0,0,.18)" stroke-width="1.4"/><path d="M12 6c1-3 2-4 3-4-1 1-1 3-1 4z" fill="#3d7a2a"/></svg>',
      '<svg viewBox="0 0 24 24"><path d="M12 2c3 3 8 4 9 10-4 1-6 4-9 10-3-6-5-9-9-10 1-6 6-7 9-10z" fill="var(--leaf,#d4a017)"/><path d="M12 4v16" stroke="rgba(0,0,0,.25)" stroke-width="1"/></svg>',
      '<svg viewBox="0 0 24 24"><path d="M6 9c0-3 3-5 6-5s6 2 6 5H6z" fill="#6b3a1f"/><path d="M7 9h10c0 5-3 9-5 11-2-2-5-6-5-11z" fill="#c8843a"/><path d="M12 2v3" stroke="#3a1f0e" stroke-width="1.6" stroke-linecap="round"/></svg>'
    ]
  };
  var LEAF = ['#d4a017', '#e0a030', '#c4622d', '#f0c060', '#b5451b', '#e8731a'];

  function highlightParent(season) {
    var parent = PARENT[season];
    if (!parent) return;
    document.querySelectorAll('[data-season-tab]').forEach(function (el) {
      el.setAttribute('aria-selected', el.getAttribute('data-season') === parent ? 'true' : 'false');
    });
  }

  function particles(season) {
    var shapes = SHAPES[season];
    if (!shapes) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-season-particles]').forEach(function (host) {
      host.innerHTML = '';
      var frag = document.createDocumentFragment();
      var count = 20;
      for (var i = 0; i < count; i++) {
        var p = document.createElement('span');
        p.className = 's-particle';
        var shape = shapes[i % shapes.length];
        var big = (season === 'halloween' && i % 3 === 0) || (season === 'thanksgiving' && i % 4 === 0);
        var size = (big ? 24 : 12) + Math.random() * 16;
        p.style.setProperty('--size', size + 'px');
        p.style.setProperty('--dur', 9 + Math.random() * 12 + 's');
        p.style.setProperty('--delay', -Math.random() * 18 + 's');
        p.style.setProperty('--drift', (Math.random() * 160 - 80).toFixed(0) + 'px');
        var spin = (season === 'halloween' || big) ? '0deg' : (Math.random() * 720 - 360).toFixed(0) + 'deg';
        p.style.setProperty('--spin', spin);
        p.style.setProperty('--alpha', (0.55 + Math.random() * 0.4).toFixed(2));
        p.style.left = (Math.random() * 100).toFixed(1) + '%';
        if (season === 'thanksgiving') p.style.setProperty('--leaf', LEAF[i % LEAF.length]);
        p.innerHTML = shape;
        frag.appendChild(p);
      }
      host.appendChild(frag);
    });
  }

  function boot() {
    var season = root.getAttribute('data-season');
    if (!PARENT[season]) return;
    highlightParent(season);
    particles(season);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
